<template>
        <div class="container withdrawal">
            <div class="">
                <h3 class="text-center student-form__title" id="">
                    <b>Withdrawal Form</b>
                    </h3>
            </div>
            <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Date of Withdrawal(Last day of attendance at school)</label>
                    <el-date-picker v-model="studentWithdrawalDate" format="dd/MM/yyyy"
                                    value-format="dd/MM/yyyy" type="date"
                                    placeholder="Pick a day" disabled></el-date-picker>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Student NO</label>
                    <input v-model="inputStudentIndexNO"
                           type="text" class="form-control form__input" disabled>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>*Child/Student Name</label>
                    <input v-model="inputStudentName" :class="{ 'requiredFields': $v.inputStudentName.$error }"
                           type="text" class="form-control form__input" :disabled="disabledForm">
                    <div class="requiredFieldsMsg" v-if="$v.inputStudentName.$error">
                        Student name required
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>*Level</label>
                    <input v-model="inputStudentLevel" :class="{ 'requiredFields': $v.inputStudentLevel.$error }"
                           type="text" class="form-control" :disabled="disabledForm">
                    <div class="requiredFieldsMsg" v-if="$v.inputStudentLevel.$error">
                        Student Level required
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>*Class</label>
                    <input v-model="inputStudentClass" :class="{ 'requiredFields': $v.inputStudentClass.$error }"
                           type="text" class="form-control" :disabled="disabledForm">
                    <div class="requiredFieldsMsg" v-if="$v.inputStudentClass.$error">
                        Student Class required
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>*Session:Morning/Afternoon/etc</label>
                    <input v-model="ddlSession" :class="{ 'requiredFields': $v.ddlSession.$error }"
                           type="text" class="form-control" :disabled="disabledForm">
                    <div class="requiredFieldsMsg" v-if="$v.ddlSession.$error">
                        Student Session required
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <label>**Reason for Withdrawal</label>
                    <el-select v-model="ddlWithdrawalReason" :class="{ 'requiredFields': $v.ddlWithdrawalReason.$error}"
                               class="w-100" placeholder="Please Select" :disabled="disabledForm" style="border: 1px solid #eee;">
                        <el-option v-for="item in options" :key="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-model="textAreaOthersReason"  v-if="ddlWithdrawalReason=='Others'" type="textarea"
                              :class="{ 'requiredFields': $v.ddlWithdrawalReason.$error}"
                              :rows="4" maxlength="150" placeholder="Please input reason" :disabled="disabledForm"></el-input>
<!--                    <div class="requiredFieldsMsg" v-if="$v.ddlWithdrawalReason.$error||(ddlWithdrawalReason=='Others'&&!textAreaOthersReason)">-->
                        <div class="requiredFieldsMsg" v-if="$v.ddlWithdrawalReason.$error||(ddlWithdrawalReason=='Others'&&!textAreaOthersReason)">
                        Reason for Withdrawal required
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><br></div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">I wish to inform the School of my intention to withdraw my child. I understand the
                    need to give a minimum of 8 term-weeks, fee-paying notice, prior to the withdrawal date, for a full refund of deposit. Any balance that
                    is refundable from the deposit will be paid by cheque after that date. I understand that once my child has formally withdrawn from the
                    school, re-registration at Etonhouse schools will not be permitted unless approved by the Board of Management.</div>
            </div>
            <div class="">
            <h5 class="text-left student-form__title">
                <b>Fee Protection Scheme (FPS)</b><br>
                The School will terminate the insurance under FPS on the student’s last day of School as stated above.
            </h5>

            <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>**Name of applicant submitting this notice</label>
                    <input type="text" :class="{ 'requiredFields': $v.inputApplicantName.$error}"
                           class="form-control" v-model="inputApplicantName" :disabled="disabledForm">
                    <div class="requiredFieldsMsg" v-if="$v.inputApplicantName.$error">
                        Applicant name required
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Name on cheque if refund is applicable</label>
                    <input type="text" class="form-control" v-model="inputNameOnCheque" :disabled="disabledForm">
                </div>
            </div>
        </div>

            <div class="">
                <h5 class="text-left student-form__title">
                    <b>Parent Contact/Detail</b><br>
                </h5>
                <div class="row form-group__wrapper">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <label>*Parent Name</label>
                        <input type="text" :class="{ 'requiredFields': $v.inputParentName.$error}"
                               class="form-control" v-model="inputParentName" :disabled="disabledForm">
                        <div class="requiredFieldsMsg" v-if="$v.inputParentName.$error">
                            Parent name required
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <label>*Parent Email</label>
                        <input type="text" :class="{ 'requiredFields': $v.inputParentEmail.$error}"
                               class="form-control" v-model="inputParentEmail" :disabled="disabledForm">
                        <div class="requiredFieldsMsg" v-if="$v.inputParentEmail.$error">
                            Parent email required
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <label>*Contact</label>
                        <input type="text" :class="{ 'requiredFields': $v.inputParentContact.$error}"
                               class="form-control" @keypress="isNumber" v-model="inputParentContact" :disabled="disabledForm">
                        <div class="requiredFieldsMsg" v-if="$v.inputParentContact.$error">
                            Parent contact required
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <el-row>
                            <el-col><label :class="{ 'requiredFields': $v.inputParentSignature.$error}">**Please Sign Here {{lblTodayDate}})</label></el-col>
                            <el-col style="text-align: left"> <el-button v-on:click="showParentSignatureModal()" type="primary" icon="el-icon-edit"
                                                                         :disabled="disabledForm"></el-button></el-col>
                            <div class="requiredFieldsMsg" v-if="$v.inputParentSignature.$error">
                                Parent Signature required
                            </div>
                        </el-row>
                        <el-row style="text-align: left">
                            <img v-if="inputParentSignature" :src="inputParentSignature" type="file" height="150px" width="300px"
                                 class="imgParentSignature" />
                        </el-row>

                    </div>
                </div>
            </div>
            <hr>
            <div style="border-width: 5px;" v-if="showOfficeUseOnlyDiv" class="">
                <h5 class="text-left student-form__title">
                    <b>(Office use only)</b><br>
                </h5>
                <div class="row form-group__wrapper">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <label>*Remark</label>
                        <input type="text" class="form-control" v-model="inputRemark">
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <label>other</label>
                        <input type="text" class="form-control" v-model="inputOther">
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <label>Contact</label>
                        <input type="text" class="form-control" v-model="inputContact">
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <label>Signature {{lblTodayDate}}</label>
                        <textarea rows="3" class="textArea" v-model="inputOfficerSignature"></textarea>
                    </div>
                </div>
            </div>

            <el-row style="text-align: right">
                <el-button type="primary" v-on:click="Validation()" round :disabled="disabledForm">Submit</el-button>
            </el-row>
            <br>

            <b-modal id="ParentSignatureModal" size="lg" title="Please sign here" ok-only ok-variant="secondary"
                     hide-footer ref="showParentSignatureModal">
                <div class="col-12 mt-2">

                    <VueSignaturePad
                            id="signature"
                            width="100%"
                            height="500px"
                            ref="signaturePad"
                            :options = "{onBegin:()=>
                        {this.$refs.signaturePad.resizeCanvas()}}"
                    />

                    <br>
                    <div>
                        <el-button @click="save">Save</el-button>
                        <el-button @click="undo">Undo</el-button>
                        <el-button @click="clear">Clear</el-button>
                    </div>
                </div>
            </b-modal>

        </div>
</template>

<script>
    import DataSource from "../data/datasource";
    import VueSignaturePad from 'vue-signature-pad';
    import Vue from 'vue';
    import {required, requiredIf, requiredUnless, email} from "vuelidate/lib/validators";
    Vue.use(VueSignaturePad);
    export default {
        name: "WithdrawForm",
        data(){
            return{
                options:[{
                    value: 'Transfer outside Singapore',
                    label: 'Transfer outside Singapore'
                },{
                    value: 'Repatriating to home country',
                    label: 'Repatriating to home country'
                },{
                    value: 'Transferring to a local school',
                    label: 'Transferring to a local school'
                },{
                    value: 'Transferring to another International School in Singapore',
                    label: 'Transferring to another International School in Singapore'
                },{
                    value: 'Others',
                    label: 'Others'
                }],
                //todo: add on and validation
                showOfficeUseOnlyDiv: false,
                textAreaOthersReason: '',
                //todo: add on and validation

                //todo hardcore for testing
                inputStudentIndexNO:'',
                //todo hardcore for testing

                inputNoticeDate:'',
                inputStudentName:'',
                inputStudentLevel:'',
                inputStudentClass:'',
                ddlSession:'',
                inputLastSchoolDate:'',
                ddlWithdrawalReason:'',

                //todo refund
                inputNameOnCheque:'',
                inputApplicantName:'',
                //todo refund

                //todo parent detail/contact
                lblTodayDate:'',
                inputParentName:'',
                inputParentEmail:'',
                inputParentContact:'',
                inputParentSignature:'',
                //todo parent detail/contact

                //todo office use
                inputRemark:'',
                inputOther:'',
                inputOfficerSignature:'',
                //todo office use

                ID:'',
                isEncrypted:'',

                //todo student withdraw info binding
                studentID:'',
                studentName:'',
                studentLevel:'',
                studentClass:'',
                studentWithdrawalDate:'',
                studentWithdrawID:'',
                stuInfoList: {},
                studentDetail: {},
                sponsor_type: '',
                inputCreationDate: '',

                disabledForm: false,
                //todo student withdraw info binding

                activeTab:'',
            }
        },
        async mounted(){
            this.ID = decodeURI(this.$route.query.ID);
            console.log(this.ID);
            if(this.ID){
                await this.getWithdrawDetail();
            }
            else{
                //todo if cannot get ID
            }
            this.lblTodayDate = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear();
        },
        validations:{
            inputStudentName:{required},
            inputStudentLevel:{required},
            inputStudentClass:{required},
            ddlSession:{required},
            ddlWithdrawalReason:{required},
            textAreaOthersReason:{required},
            inputApplicantName:{required},
            inputParentName:{required},
            inputParentEmail:{required},
            inputParentContact:{required},
            inputParentSignature:{required},
        },
        methods:{
            isNumber(evt){
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which)?evt.which:evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            showParentSignatureModal(){
                this.$refs.showParentSignatureModal.show();
            },
            async getWithdrawDetail(){
                try{
                    //todo ***take note, must put parameter 'yes'.
                    const resp = await DataSource.shared.getWithdrawFormDetail('','','yes',this.ID,'');
                    if(resp){
                        //todo bind back to withdraw Form
                        this.stuInfoList =  resp.Table;
                        this.stuInfoList.forEach(m=>{
                            this.inputStudentIndexNO =  m.IndexNo;
                            this.studentID = m.WithdrawStudentID;
                            this.inputStudentName = m.StudentFullName;
                            this.studentWithdrawID = m.WithdrawID;
                            this.studentWithdrawalDate = m.WithdrawDate;
                            if(m.WithdrawStatus ==='Active'){
                                this.inputStudentLevel = m.StudentLevel;
                                this.inputStudentClass = m.StudentClass;
                                this.ddlSession = m.StudentSession;
                                this.inputParentName = m.FatherFullName;
                                this.inputParentEmail = m.FatherEmail;
                                this.inputParentContact = m.FatherContact;
                            }else if(m.WithdrawStatus==='Closed'){
                                this.inputStudentIndexNO =  m.WithdrawIndexNo;
                                this.inputStudentName = m.WithdrawStudName;
                                this.inputStudentLevel = m.WithdrawCourse;
                                this.inputStudentClass = m.WithdrawClass;
                                this.ddlSession = m.WithdrawSession;
                                this.inputParentName = m.WithdrawParentName;
                                this.inputParentEmail = m.WithdrawParentEmail;
                                this.inputParentContact = m.WithdrawParentContact;
                            }
                            this.ddlWithdrawalReason = m.WithdrawReason;
                            this.textAreaOthersReason = m.WithdrawReason;
                            this.inputNameOnCheque = m.WithdrawRefundDocNO;
                            this.inputApplicantName = m.WithdrawApplicantName;
                            this.inputParentSignature = m.WithdrawParentSignature;

                            if(m.WithdrawStatus==='Closed'){
                                this.disabledForm = true;
                            }
                        });
                    }
                }
                catch(e){
                    console.log(e);
                }
            },
            async saveWithdrawForm(){
                try{
                    //validation for require field;

                    let reason =  '';
                    if(this.ddlWithdrawalReason==='Others'){
                        reason = this.textAreaOthersReason;
                    }else{
                        reason = this.ddlWithdrawalReason;
                    }

                    var withdrawObj = {
                        WithdrawID : this.studentWithdrawID,
                        WithdrawStudentID : this.studentID,
                        WithdrawIndexNo : this.inputStudentIndexNO,
                        WithdrawDate : this.studentWithdrawalDate,
                        WithdrawLastDay : this.inputLastSchoolDate,
                        WithdrawStudName : this.inputStudentName,
                        WithdrawCourse : this.inputStudentLevel,
                        WithdrawClass : this.inputStudentClass,
                        WithdrawSession : this.ddlSession,
                        WithdrawReason : reason,

                        //todo refund
                        WithdrawRefundChequeName : this.inputNameOnCheque,
                        WithdrawApplicantName : this.inputApplicantName,
                        //WithdrawOfficeRefundType:'',
                        //todo refund

                        //todo parent detail/contact
                        WithdrawParentName : this.inputParentName,
                        WithdrawParentEmail : this.inputParentEmail,
                        WithdrawParentContact : this.inputParentContact,
                        inputParentSignature : this.inputParentSignature,
                        //todo parent detail/contact

                        //todo office use
                        // WithdrawOfficeUseRemark : this.inputRemark,
                        // inputOther : this.inputOther,
                        // withdrawObj.inputOfficerSignature = this.inputOfficerSignature;
                        //todo office use
                    };

                    const resp =  await DataSource.shared.saveWithdrawForm(JSON.stringify(withdrawObj),
                        this.inputParentSignature,this.inputOfficerSignature);
                    console.log('resp',resp);
                    if (resp) {
                        if (resp.code === '88') {
                            window.location.replace('/');
                        } else if (resp.code === '99')
                        {
                            this.$notify({
                                title: 'Error',
                                message: 'Error 99',
                                type: 'error'
                            });
                        }
                        else if(resp.code === '4'){
                            this.$notify.error({
                                title: 'Error',
                                message: 'You already submitted withdraw form!, Please contact our administrator',
                                type: 'Error'
                            });
                        }
                        else if(resp.code === '1'){
                            this.$notify({
                                title: 'Success',
                                message: 'Save Successful!',
                                type: 'success'
                            });
                            this.disabledForm = true;
                            window.location.replace('/public/ThankYouPage');
                        }
                    }

                }
                catch(e){
                    this.results = e;
                }
            },
            async save(){
                try{

                    const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                    console.log(isEmpty);
                    if(data)
                    { this.inputParentSignature = data;
                        this.$refs.showParentSignatureModal.hide();
                    }
                }
                catch (e) {
                    this.results = e;
                }
            },
            async undo(){
                try{
                    this.$refs.signaturePad.undoSignature();
                }
                catch (e) {
                    this.results = e;
                }
            },
            async clear(){
                try{
                    this.$refs.signaturePad.clearSignature();
                }
                catch (e) {
                    this.results = e;
                }
            },
            async onBegin() {
                console.log('=== Begin ===');
                //this.$refs.signaturePad.resizeCanvas();
            },
            async onEnd() {
                console.log('=== End ===');
            },
            async Validation() {
                try {
                    this.$v.$touch();
                    this.activeTab = "Student";
                    if (this.$v.$error) {
                        //this.$nextTick(() => this.$refs.studentPageMain.focus())
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill in all * fields & at least one of ** field'
                        });
                        return;
                    }

                    await this.saveWithdrawForm();

                } catch (e) {
                    this.results = e;
                }
            },
        }
    }
</script>

<style scoped>
    .withdrawal {
        background: #ffffff;
    }
    .requiredFields {
        border-color: #f79483;
    }

    .requiredFieldsMsg {
        color: red;
        font-weight: bold;
    }
</style>

<style>
    .WithdrawForm .topbar {
        display: none;
    }
</style>